import { Link, useParams } from 'react-router-dom'
import { AboInvoiceDocument } from './AboInvoiceDocument'
import { useAboInvoice } from './useBilling'

/**
 * Druck-/PDF-Ansicht einer einzelnen Abo-Rechnung (Route /print/abo-invoice/:id, auth-gated, ohne App-Shell).
 * Wie die §14-Kundenrechnung: „Drucken / als PDF" ruft window.print() — der Nutzer speichert im Dialog als PDF.
 * Der Beleg ist ein eingefrorener GoBD-Snapshot (Backend), hier wird nur gerendert.
 */
export function AboInvoicePrintPage() {
  const { id: idParam } = useParams()
  const id = Number(idParam)
  const query = useAboInvoice(id)

  if (query.isLoading) return <div className="muted">Rechnung wird geladen…</div>
  if (query.error || !query.data) {
    return (
      <div className="error" role="alert">
        Rechnung konnte nicht geladen werden.
      </div>
    )
  }
  return (
    <main className="wf-print" data-theme="light">
      <div className="wf-print__bar">
        <Link to="/einstellungen/abo" className="wf-btn wf-btn--ghost">
          ← Zurück
        </Link>
        <div className="wf-print__baractions">
          <button type="button" className="wf-btn wf-btn--primary" onClick={() => window.print()}>
            Drucken / als PDF
          </button>
        </div>
      </div>
      <AboInvoiceDocument invoice={query.data.invoice} />
    </main>
  )
}
